import script from "./UsageTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UsageTable.vue?vue&type=script&setup=true&lang=js"

import "./UsageTable.vue?vue&type=style&index=0&id=6458d276&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6458d276"]])

export default __exports__